/**
 * Full Width Media pull-under margin — fixed inline px inset (repeats / care-of-gerd pattern).
 *
 * FWM must NOT keep relying on live `margin-top: calc(var(--header-height-fixed) + …)`
 * after first paint: deferred modules rewrite related vars and the hero jumps.
 * This script measures announcement + header once and sets section.style.marginTop;
 * later CSS var churn does not move the hero.
 *
 * Loaded as a classic script from `section-full-width-media.liquid` when
 * `hero_banner` is false (overlap / transparent header).
 */
(function () {
  /** Theme setting — not scroll state. Margin is layout; it must not change after first apply. */
  function isTransparentPullUnderSetting() {
    const header = document.getElementById('header');
    if (!header) return false;

    try {
      const settings = JSON.parse(header.getAttribute('data-settings') || '{}');
      return !!settings.transparent;
    } catch {
      return (
        getComputedStyle(document.documentElement).getPropertyValue('--header-is-transparent').trim() ===
        '1'
      );
    }
  }

  function parsePxVar(name) {
    const raw = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    const value = parseFloat(raw);
    return Number.isFinite(value) ? Math.round(value) : 0;
  }

  function readChromeHeightPx() {
    // Prefer the live header box so the locked margin matches real chrome even if
    // only the generic Liquid fallback was available on :root.
    const header = document.getElementById('header');
    const measured = header ? Math.round(header.offsetHeight) : 0;
    if (measured > 0) return measured;
    return parsePxVar('--header-height-fixed');
  }

  /**
   * @param {HTMLElement | null | undefined} section
   */
  function applyPullUnderMargin(section) {
    if (!section) return;

    if (section.dataset.fwmPullUnderApplied === '1') {
      return;
    }

    if (!isTransparentPullUnderSetting()) {
      return;
    }

    const chrome = readChromeHeightPx();
    if (chrome <= 0) return;

    section.style.marginTop = `-${chrome}px`;
    section.dataset.fwmPullUnderApplied = '1';
  }

  function applyAllPullUnderMargins() {
    document.querySelectorAll('banner-hero[data-fwm-pull-under]').forEach((hero) => {
      const sectionId = hero.getAttribute('data-fwm-pull-under');
      if (!sectionId) return;
      applyPullUnderMargin(document.getElementById(`shopify-section-${sectionId}`));
    });
  }

  window.themeApplyFwmPullUnderMargins = applyAllPullUnderMargins;

  applyAllPullUnderMargins();

  let resizeTimer = null;
  window.addEventListener(
    'resize',
    () => {
      if (resizeTimer !== null) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        resizeTimer = null;
        // Only apply to sections that have not locked yet (e.g. theme editor re-render).
        applyAllPullUnderMargins();
      }, 150);
    },
    { passive: true },
  );
})();
